import { getExampleNumber } from 'libphonenumber-js'
import examples from 'libphonenumber-js/examples.mobile.json'
import type { CountryCode, Examples } from 'libphonenumber-js'

const mobileExamples = examples as unknown as Examples

/**
 * Returns a national mobile-number example that can be entered into PhoneInput.
 * The country prefix is rendered separately, so it is deliberately omitted here.
 */
export default function getPhonePlaceholder(countryCode: string): string | undefined {
  const exampleNumber = getExampleNumber(countryCode as CountryCode, mobileExamples)

  // PhoneInput accepts digits and spaces. Preserve the familiar national grouping
  // while avoiding punctuation that the input cannot accept.
  return exampleNumber?.formatNational().replace(/[^0-9]+/g, ' ').trim()
}
